import HailIcon from "@mui/icons-material/Hail";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import { Typography } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import styles from "@/components/todos/todoMetadataChips.module.css";

interface TodoMetadataChipsProps {
  done: boolean;
  completedOn?: string | null;
  completedByName?: string | null;
  createdByName?: string | null;
  showCompletedBy?: boolean;
  showCreatedBy?: boolean;
}

export default function TodoMetadataChips({
  done,
  completedOn,
  completedByName,
  createdByName,
  showCompletedBy = false,
  showCreatedBy = false,
}: TodoMetadataChipsProps) {
  const { t } = useTranslation();
  const completedDate = dayjs(completedOn);
  const formattedCompletedOn =
    completedOn && completedDate.isValid()
      ? completedDate.format("DD.MM.YYYY, HH:mm")
      : "";
  const shouldShowCreatedBy = showCreatedBy && Boolean(createdByName);
  const shouldShowCompletedOn = done && Boolean(formattedCompletedOn);
  const shouldShowCompletedBy =
    done && showCompletedBy && Boolean(completedByName);

  if (
    !shouldShowCreatedBy &&
    !shouldShowCompletedOn &&
    !shouldShowCompletedBy
  ) {
    return null;
  }

  return (
    <div className={styles.metadataChips} data-testid="todo-metadata-chips">
      {shouldShowCompletedOn && (
        <div className={styles.metadataChip}>
          <EventAvailableIcon className={styles.completedIcon} />
          <Typography component="span" variant="body2">
            {t("todo_completed_on")}{" "}
            <time
              className={styles.detailValue}
              dateTime={completedOn ?? undefined}
            >
              {formattedCompletedOn}
            </time>
          </Typography>
        </div>
      )}
      {shouldShowCompletedBy && (
        <div className={`${styles.metadataChip} ${styles.completedBy}`}>
          <HowToRegIcon className={styles.completedByIcon} />
          <Typography component="span" variant="body2">
            {t("todo_completed_by")}{" "}
            <span className={styles.detailValue}>{completedByName}</span>
          </Typography>
        </div>
      )}
      {shouldShowCreatedBy && (
        <div className={`${styles.metadataChip} ${styles.createdBy}`}>
          <HailIcon className={styles.createdByIcon} />
          <Typography component="span" variant="body2">
            {t("todo_created_for_you_by")}{" "}
            <span className={styles.detailValue}>{createdByName}</span>
          </Typography>
        </div>
      )}
    </div>
  );
}
